import Vue from 'vue';
import Router from 'vue-router';
//import store from '@/store';
import AWN from 'awesome-notifications';
import { checkAuthorization, removeAuthorization } from '@/services/auth';
import { getUrlProject, getUrlLang, getUrlQuery } from '@/services/check';
import { getLangString } from '@/services/lang';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false });
let notifier = new AWN({ position: 'top-right' });
Vue.use(Router);

const routes = [
    {
        path: '/2fa-query',
        name: '/2fa',
        meta: { label: '2FA', requiresAuth: true },
        component: () => import(/* webpackChunkName: "Index" */ '@/views/2FA/Index.vue'),
    },
    {
        path: '/2fa-query/auth/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "Login" */ '@/views/pages/Login.vue'),
    },
    {
        path: '/2fa-query/404',
        name: '404',
        component: () => import(/* webpackChunkName: "Error" */ '@/views/pages/Page404.vue'),
    },
    {
        path: '/2fa-query/500',
        name: '500',
        component: () => import(/* webpackChunkName: "component-error" */ '@/views/pages/Page500.vue'),
    },
    { path: '/*', redirect: '/2fa-query/404' },
];

const router = new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'active',
    scrollBehavior: () => ({ y: 0 }),
    routes,
});

router.beforeEach(async (to, from, next) => {
    // 如果 router 轉跳的頁面需要驗證 requiresAuth: true
    //console.log('router-->', to, from, next);
    NProgress.start();
    if (to.matched.some(record => record.meta.requiresAuth)) {
        let [checkLogin, result] = await checkAuthorization();
        //console.log('router check auth-->', checkLogin);
        if (checkLogin) {
            next();
        } else {
            let project_id = getUrlProject(),
                lang = getUrlLang(),
                i18n = getLangString(lang);

            removeAuthorization();
            notifier.warning(i18n.alert.auth_fail);
            next({ path: `/2fa-query/auth/login${getUrlQuery(project_id, lang)}` });
        }
    } else {
        next(); // 往下繼續執行
    }
});

router.afterEach(() => {
    NProgress.done();
});

export default router;
